/**
 * Generates a random password that meets the requirements:
 * - At least 6 characters
 * - At least one uppercase letter
 * - At least one number
 * 
 * @param {number} length - Length of the password (minimum 6)
 * @returns {string} - A random password
 */
export const generateRandomPassword = (length = 10) => {
    // Ensure minimum length of 6
    const passwordLength = Math.max(length, 6);
    
    // Character sets
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const allChars = lowercase + uppercase + numbers;
    
    // Start with one uppercase and one number to ensure requirements
    let password = 
        uppercase.charAt(Math.floor(Math.random() * uppercase.length)) +
        numbers.charAt(Math.floor(Math.random() * numbers.length));
    
    // Fill the rest with random characters
    for (let i = 0; i < passwordLength - 2; i++) {
        password += allChars.charAt(Math.floor(Math.random() * allChars.length));
    }
    
    // Shuffle the password to avoid predictable pattern
    password = password.split('').sort(() => 0.5 - Math.random()).join('');
    
    return password;
};

/**
 * Copies text to clipboard
 * 
 * @param {string} text - Text to copy to clipboard
 * @returns {Promise<boolean>} - Whether the copy was successful
 */
export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (err) {
        console.error('Failed to copy: ', err);
        return false;
    }
}; 